import { Card, Image } from "react-bootstrap";


function ProjectBlock(props) {
	return (<>
		<Card  bg="light">
			<Card.Header>
				<a href={props.url} className="image fit thumb">
					<Image src={props.cover} alt={props.alt} />
				</a>
			</Card.Header>
			<Card.Body style={{minHeight: "261px"}}>
				<h3><a href={props.url}>{props.name}</a></h3>
				<p>{props.desc}</p>
			</Card.Body>
		</Card>
	</>)
}

export default ProjectBlock;